import React, { useState } from 'react'
import { useSelector } from '~/store/hooks'

import Scrollbar from 'react-scrollbars-custom'

import ProfileInner from '~/components/features/header/profileInner'
import ButtonClose from '~/components/core/buttonClose'

import { ArrowRight } from '~/icons/ArrowRight'

import trads from '~/intl/trads.json'

const PanelProfile = ({ togglePanel, isOpen }) => {
  // local state
  const [level, setLevel] = useState(1)
  const [activeSubnav, setActiveSubnav] = useState(null)

  // redux lang
  const lang = useSelector((state) => state.lang)

  const changeLevel = (levelTemp, activeSubnavTemp) => {
    setLevel(levelTemp)
    setActiveSubnav(activeSubnavTemp)
  }

  const backNav = () => {
    setLevel(1)
    setActiveSubnav(null)
  }

  const reinit = () => {
    togglePanel('profile')
    backNav()
  }

  return (
    <div
      className={`panel-nav panel-nav--profile bg-blue flex ${level > 1 && 'has-subnav-open'} ${isOpen && 'is-visible'}`}
    >
      <div className="fluid-grid flex flex-col md:flex-row">
        <ButtonClose
          action={() => {
            reinit()
          }}
          color="white"
          className="panel-nav__close"
        />

        <div className="row">
          <div className="col-12 md-col-6 lg-col-5 lg-col-offset-1">
            <span className="title-cut title-cut--blue-medium title-cut--small text-blue">
              {trads[lang]?.header?.profileTitle}
            </span>

            <div className="col-12 md-col-6 lg-col-5 xl-col-4 xl-col-offset-1 panel-nav__profile-wrap">
              <button
                className={`panel-nav__back panel-nav__back--profile ${level > 1 ? 'is-visible' : ''}`}
                onClick={() => backNav()}
              >
                <ArrowRight className="icon-white" width="9" height="10" />
                <span className="text-label">{trads[lang]?.header?.back}</span>
              </button>

              {typeof window !== 'undefined' && window.innerWidth < 768 ? (
                <ProfileInner
                  activeSubnav={activeSubnav}
                  changeLevel={changeLevel}
                  lang={lang}
                />
              ) : (
                <Scrollbar style={{ height: '100%' }}>
                  <ProfileInner
                    activeSubnav={activeSubnav}
                    changeLevel={changeLevel}
                    lang={lang}
                  />
                </Scrollbar>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PanelProfile
